/** Recent activities for hub/calendar/kanban/reports — rolling window. */
export const ACTIVITIES_RECENT_LOOKBACK_DAYS = 90;

/** Cap on recent-activities listener (hub, calendar, kanban). */
export const ACTIVITIES_RECENT_LIMIT = 500;

/** Per-entity activity history cap (lead/deal/project panels). */
export const ACTIVITIES_ENTITY_LIMIT = 200;

/** ISO timestamp on or after which recent-activities queries include docs. */
export function activitiesRecentLookbackDate(
  days = ACTIVITIES_RECENT_LOOKBACK_DAYS,
  now = new Date(),
): Date {
  const d = new Date(now.getTime());
  d.setDate(d.getDate() - days);
  d.setHours(0, 0, 0, 0);
  return d;
}
